<template>
  <div>
    <Hero class="text-center">
      <h1 class="mt-5 mb-3">
        {{ $t('message.testDrive.requestSubmittedHeader') }}
        <img :src="require('@/assets/fa/party-popper.svg')" width="24" height="24" class="ml-2 mb-2" alt="" />
      </h1>
      <p class="text-muted mx-auto mt-4">{{ $t('message.testDrive.requestSubmittedDescription') }}</p>
      <MobialisButton v-if="!hideAllCloseBtns" class="mt-4 w-auto" @click="clickBtn()" data-cy="returnBtn"
        >{{ $t('message.common.returnToVehicle') }}
      </MobialisButton>
    </Hero>
  </div>
</template>
<script>
import Hero from '@/components/test-drive/Hero.vue';
import { modalMethods } from '@/mixins';
import log from '@/services/log';

export default {
  name: 'RequestSubmitted',
  mixins: [modalMethods],
  components: {
    Hero,
  },
  methods: {
    async clickBtn() {
      await this.closeModal().catch(error =>
        log('Error completing lead after receiving close message from SDK.', error)
      );
    },
  },
  async mounted() {
    this.$store.commit('SET_DHS_STATE', ['testDrive', 'complete']);
    try {
      await this.$store.dispatch('lead/updateMetadata');
      await this.$store.dispatch('lead/completeLead');
    } catch (err) {
      log('Error completing lead after submitting test drive', err);
      this.$router.push({ path: `${this.getProductBasePath()}/error` });
    }
  },
};
</script>

<style lang="scss" scoped>
p {
  max-width: 500px;
}

@media (max-width: 576px) {
  .btn {
    width: 100% !important;
  }
}
</style>
